var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgInfinityConstructor = function SvgInfinityConstructor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C12 12.5 8.7 17 5.4 17C2.96995 17 1 14.9853 1 12.5C1 10.0147 2.96995 8 5.4 8C7.05 8 8.26503 9.125 9.61127 10.25",
    stroke: "#727281",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12 12.5C12 12.5 15.3 8 18.6 8C21.0301 8 23 10.0147 23 12.5C23 14.9853 21.0301 17 18.6 17C16.95 17 15.735 15.875 14.3887 14.75",
    stroke: "#727281",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
};
export default SvgInfinityConstructor;